module.exports = {
  language: 'Русский',
  applierApplicationCenter: {
    selectCenterTip: 'Выбрать этот центр'
  },
  multiplePage: {
    moreInfomation: 'Больше информации',
    recommendedServices: 'Рекомендуемые услуги'
  },
  checkoutConfirm: {
    ordered: 'Заказано',
    purchased: 'Куплено'
  },
  personal: {
    purgePopupContent:
      'Извините, ваша заявка была удалена из-за политики безопасности, вы можете связаться с нами, если хотите подать заявку в ближайшее время.'
  },
  login_maximum: {
    errorContent: 'К сожалению, вы достигли максимального времени входа сегодня, попробуйте на следующий день.'
  },
  nationalityKay: 'ru-ru',
  noneSelectedText: 'Пожалуйста, выберите',
  multiselect: {
    deselect: 'Нажмите Enter, чтобы удалить',
    select: 'Нажмите Enter, чтобы выбрать',
    selected: 'Выбрано'
  },
  enter: ' Войти',
  upload_failed: 'Ошибка загрузки. Повторите попытку.',
  due_time: 'Срок',
  requirement: 'Требование',
  something_went_wrong_please_retry: 'Что-то пошло не так, пожалуйста, попробуйте еще раз.',
  valid_rediret_home_page_popup_content:
    'Произошло исключение при входе в систему. Вы пытаетесь перейти на домашнюю страницу [ {country} - {center} ] для входа в систему? Если да, пожалуйста, нажмите "Подтвердить"; если нет, пожалуйста, нажмите "Отмена" для повторного выбора.',
  invalid_rediret_home_page_popup_content:
    'Произошло исключение при входе в систему, пожалуйста, выберите страну и местоположение для продолжения.',
  'Temporarily not available': 'Временно недоступно',
  'Coming soon': 'Скоро в продаже'
};
